import $ from 'jquery';

import { formatCurrency } from 'chairisher/util/format';

const ShippingOptionField = () => {};

/**
 * Marshals a new jQuery object representing a shipping option
 *
 * @param {Object} data Data from which to marshal the object
 * @param {boolean=} shouldDisplayDecimalsInPrice Whether to format the option price with decimals
 */
ShippingOptionField.marshal = (data, shouldDisplayDecimalsInPrice) => {
    const $option = $($('#js-shipping-option').html());

    $option.attr({
        'data-price': data.price,
        'data-code': data.value,
        'data-pre-adjusted-price': data.pre_adjusted_price,
    });

    if (data.is_unavailable) {
        $option.addClass('inactive');
    }

    const price = formatCurrency(data.price, shouldDisplayDecimalsInPrice, true);
    $option.find('.js-shipping-option-price').text(price);

    const shippingPartnerName = data.display;
    if (data.signature_requirement_display) {
        $option.find('.js-shipping-option-signature-required').text(data.signature_requirement_display);
    }
    const title = data.estimated_arrival_timeframe;
    $option.find('.js-shipping-option-title').text(title || shippingPartnerName);
    if (title) {
        $option.find('.js-shipping-option-subtitle').text(shippingPartnerName);
    }

    const $input = $option.find('input');
    $input.attr({
        name: data.name || 'shipping_partner_code',
        value: data.value,
    });

    if (data.input_classes) {
        $input.addClass(data.input_classes);
    }

    const additionalInfoStrings = data.additional_info_strings || [];
    const $helpText = $option.find('.js-help-text');
    for (let i = 0; i < additionalInfoStrings.length; i += 1) {
        if (i > 0) {
            $helpText.append($('<br/>'));
        }
        $helpText.append(additionalInfoStrings[i]);
    }
    if (data.is_checked && data.help_text) {
        $helpText.append(
            $('<span></span>', {
                class: 'warning',
                text: data.help_text,
            }),
        );
    }

    const $titleToolTip = $option.find('.js-shipping-option-title-tooltip');
    const estimatedArrivalHoverDisplay = data.estimated_arrival_hover_display;
    if (estimatedArrivalHoverDisplay) {
        $titleToolTip.prop('title', estimatedArrivalHoverDisplay).removeClass('hidden').tooltip({ placement: 'top' });
    } else {
        $titleToolTip.addClass('hidden');
    }

    return $option;
};

export default ShippingOptionField;
